import { withTranslation } from 'react-i18next';

function Tours({ t }) {
    const tours = [
        {
            title: t("tours.tour_list.terelj.title"),
            description: t("tours.tour_list.terelj.description"),
            img_source: "/imgs/tours/gorkhi_terelj.jpeg"
        },
        {
            title: t("tours.tour_list.turtle_rock.title"),
            description: t("tours.tour_list.turtle_rock.description"),
            img_source: "/imgs/tours/terelj.jpg"
        },
        {
            title: t("tours.tour_list.aryabal.title"),
            description: t("tours.tour_list.aryabal.description"),
            img_source: "/imgs/tours/aryabal.jpg"
        },
        {
            title: t("tours.tour_list.hustai.title"),
            description: t("tours.tour_list.hustai.description"),
            img_source: "/imgs/tours/khustai.jpg"
        },
        {
            title: t("tours.tour_list.gobi.title"),
            description: t("tours.tour_list.gobi.description"),
            img_source: "/imgs/tours/gobi.jpg"
        },
        {
            title: t("tours.tour_list.bayanzag.title"),
            description: t("tours.tour_list.bayanzag.description"),
            img_source: "/imgs/tours/bayanzag.jpg"
        },
        {
            title: t("tours.tour_list.khongor.title"),
            description: t("tours.tour_list.khongor.description"),
            img_source: "/imgs/tours/khongor.jpg"
        },
        {
            title: t("tours.tour_list.yol.title"),
            description: t("tours.tour_list.yol.description"),
            img_source: "/imgs/tours/yolyn_am.jpeg"
        },
        {
            title: t("tours.tour_list.white_stupa.title"),
            description: t("tours.tour_list.white_stupa.description"),
            img_source: "/imgs/tours/white_stupa.jpg"
        },
        {
            title: t("tours.tour_list.kharkhorin.title"),
            description: t("tours.tour_list.kharkhorin.description"),
            img_source: "/imgs/tours/kharkhorin.jpg"
        },
        {
            title: t("tours.tour_list.karakorum_museum.title"),
            description: t("tours.tour_list.karakorum_museum.description"),
            img_source: "/imgs/tours/karakorum_museum.jpg"
        },
        {
            title: t("tours.tour_list.erdene_zuu.title"),
            description: t("tours.tour_list.erdene_zuu.description"),
            img_source: "/imgs/tours/erdene zuu.jpg"
        },
    ]

    return (
        <div className="px-12 py-12 mt-12">
            <div className='text-center sm:text-5xl text-4xl font-bold text-secondary mt-6 mb-12'>{t("tours.title")}</div>
            <div className='grid sm:grid-cols-3 grid-cols-1 gap-5'>
                {tours.map(tour =>
                    <div key={tour.title} className="block bg-white border border-gray-200 rounded-lg shadow-sm grid grid-cols-1">
                        <div className="h-72 w-full">
                            <img src={tour.img_source} className="rounded-t-lg w-full h-full object-cover" alt="tag" />
                        </div>
                        <div className="p-4">
                            <div className="font-bold text-center text-2xl mb-2 text-secondary">{tour.title}</div>
                            <div className='text-center mt-2 text-[14px]'>{tour.description}</div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default withTranslation()(Tours);